import { useContext, useEffect } from "react"
import { ScrollArea, Stack, Text, Checkbox, Flex, Skeleton, Box } from "@mantine/core"
import SingleCustomerContext from "../Customer-Context/SingleCustomerContext"
import { LIGHT_BLUE_BACKGROUND } from "../../../constants/colors"

const CustomersList = ({
  setChosenCustomerId,
  selectedValues,
  setSelectedValues,
  setAccountName,
  setTextQuery
}: {
  setChosenCustomerId: (customer: any) => void,
  selectedValues: string[],
  setSelectedValues: React.Dispatch<React.SetStateAction<string[]>>,
  setAccountName: React.Dispatch<React.SetStateAction<string>>,
  setTextQuery: React.Dispatch<React.SetStateAction<string>>
}) => {

  const { customersItems, isLoading, setIsSegmentSelection, } = useContext(SingleCustomerContext)

  const handleCheckboxChange = (value: string) => {

    const isUnChecking = selectedValues.includes(value) 

    if(!isUnChecking){
      setAccountName('')
      setTextQuery('')
    }

    const newCustomerIds = isUnChecking
      ? selectedValues.filter(id => id !== value)  
      : [...selectedValues, value];                
    
    setSelectedValues(newCustomerIds);
    setChosenCustomerId(value);
  };

  useEffect(() => {
    if (selectedValues.length > 0) {
      setIsSegmentSelection(false)
    }
  }, [selectedValues])

  return (
    <ScrollArea h={280} mah={280} sx={{backgroundColor: 'white'}} /* pt={4} */>
      {isLoading ? (
        <Stack>
          {[...Array(5)].map((_, index) => (
            <Stack 
              justify="center" 
              key={index} 
              pt={19}
              h={40} 
            >
              <Flex align="center" gap={8}>
                <Skeleton height={20} width={20} radius="sm" />
                <Skeleton height={20} width="50%" radius="sm" />
              </Flex>
            </Stack>
          ))}
        </Stack>
      ) : (
        Array.isArray(customersItems) && customersItems.length > 0 ? (
          <Stack>
            {customersItems.map((customer: any, index: number) => (
              <Stack 
                justify="center" 
                key={index} 
                py={10}
                px={20}
                h={40} 
                sx={{
                  borderRadius: 4,
                  '&:hover': {
                    backgroundColor: LIGHT_BLUE_BACKGROUND,
                    '& .checkbox-wrapper': {
                      opacity: 1
                    }
                  }
                }}
              >
                <Flex align="center" gap={8}>
                  <Box 
                    className="checkbox-wrapper"
                    sx={{
                      opacity: selectedValues.includes(customer._id) ? 1 : 0,
                      transition: 'opacity 0.2s ease'
                    }}
                  >
                    <Checkbox 
                      color='indigo'
                      checked={selectedValues.includes(customer._id)}
                      onChange={() => handleCheckboxChange(customer._id)}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </Box>
                  <Text>{customer.name || "No Name"}</Text>
                </Flex>
              </Stack>
            ))}
          </Stack>
        ) : (
          <Text>No accounts found</Text>
        )
      )}
    </ScrollArea>
  )
}

export default CustomersList